import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

/* ----------- * COMPONENTS * ----------- */
import { UserPopoverComponent } from '../../shared/components/user-popover/user-popover.component';
import { ItemPopoverComponent } from '../../shared/components/item-popover/item-popover.component';
import { ColorImageDropDownComponent } from '../../shared/components/dropdown-color-image/color-image-dropdown.component';

/* ----------- * MODAL_COMPONENTS * ----------- */
import { NewEventModalComponent } from '../../layouts/calendar/new-event-modal/new-event-modal.component';
import { EventDetailsComponent } from '../../layouts/calendar/event-details/event-details.component';

/* ----------- * ROUTE * ----------- */
import { SharedModule } from '../SharedModule';
import { CommentDatePipe } from '../../shared/pipes/comment-date-pipe.pipe';

import { SubsectionVersionListComponent } from '../../shared/components/subsection-version-list/subsection-version-list.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ColorPickerDirective } from 'ngx-color-picker';
import { UiSwitchModule } from 'ngx-ui-switch';
import { SectionDateStatusEditorComponent } from '../../shared/components/section-date-status-editor/section-date-status-editor.component';
import { StatusFlagComponent } from '../../shared/components/status-flag/status-flag.component';
import { StatusFlagMilestoneComponent } from '../../shared/components/status-flag-milestone/status-flag-milestone.component';
import { ProjectSubsectionSharedModule } from '../../project-subsection/project-subsection-shared.module';
import { KpfTreeWidgetComponent } from '../../layouts/my-projects/dashboard/kpf-tree-widget/kpf-tree-widget.component';
import { MediaPlayerComponent } from '../../shared/components/media-player/media-player.component';

@NgModule({
  declarations: [
    NewEventModalComponent,
    EventDetailsComponent,
    UserPopoverComponent,
    ItemPopoverComponent,
    SubsectionVersionListComponent,
    ColorImageDropDownComponent,
    KpfTreeWidgetComponent,
    StatusFlagComponent,
    StatusFlagMilestoneComponent,
    SectionDateStatusEditorComponent,
  ],
  exports: [
    NewEventModalComponent,
    EventDetailsComponent,
    UserPopoverComponent,
    ItemPopoverComponent,
    SubsectionVersionListComponent,
    ColorImageDropDownComponent,
    KpfTreeWidgetComponent,
    StatusFlagComponent,
    StatusFlagMilestoneComponent,
    SectionDateStatusEditorComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgClickOutsideDirective,
    NgbModule,
    DragDropModule,
    SharedModule,
    NgSelectModule,
    NgxSliderModule,
    ColorPickerDirective,
    UiSwitchModule,
    ProjectSubsectionSharedModule,
  ],
  providers: [CommentDatePipe, provideHttpClient(withInterceptorsFromDi())],
})
export class ProjectSharedModule {}
